
import { lazy } from "react";
import Login from "../layout/auth/Login";
import PinValidate from "../layout/auth/PinValidate";
import SigninKiosk from "../layout/auth/SigninKiosk";
import AddNewProfile from "../pages/adminModule/newEnquiry/AddNewProfile";

// admin route 
const adminRoute = {
    Report: lazy(() => import("../pages/adminModule/report/Report")),
    ActivityDetails: lazy(() => import("../pages/adminModule/activity/ActivityDetails")),
    AddBathRoomActivity: lazy(() => import("../pages/adminModule/activity/bathroom/AddBathRoomActivity")),
    BathroomActivity: lazy(() => import("../pages/adminModule/activity/bathroom/BathroomActivity")),
    AddBottleActivity: lazy(() => import("../pages/adminModule/activity/bottle/AddBottleActivity")),
    BottleActivity: lazy(() => import("../pages/adminModule/activity/bottle/BottleActivity")),
    AddLearnActivity: lazy(() => import("../pages/adminModule/activity/learning/AddLearnActivity")),
    LearningActivity: lazy(() => import("../pages/adminModule/activity/learning/LearningActivity")),
    AddMealActivity: lazy(() => import("../pages/adminModule/activity/meal/AddMealActivity")),
    MealActivity: lazy(() => import("../pages/adminModule/activity/meal/MealActivity")),
    AddMedsActivity: lazy(() => import("../pages/adminModule/activity/meds/AddMedsActivity")),
    MedsActivity: lazy(() => import("../pages/adminModule/activity/meds/MedsActivity")),
    AddMoodActivity: lazy(() => import("../pages/adminModule/activity/mood/AddMoodActivity")),
    MoodActivity: lazy(() => import("../pages/adminModule/activity/mood/MoodActivity")),
    AddNapActivity: lazy(() => import("../pages/adminModule/activity/nap/AddNapActivity")),
    NapActivity: lazy(() => import("../pages/adminModule/activity/nap/NapActivity")),
    AddNoteActivity: lazy(() => import("../pages/adminModule/activity/note/AddNoteActivity")),
    NoteActivity: lazy(() => import("../pages/adminModule/activity/note/NoteActivity")),
    AddPhotoActivity: lazy(() => import("../pages/adminModule/activity/photo/AddPhotoActivity")),
    PhotoActivity: lazy(() => import("../pages/adminModule/activity/photo/PhotoActivity")),
    AddVideoActivity: lazy(() => import("../pages/adminModule/activity/video/AddVideoActivity")),
    VideoActivity: lazy(() => import("../pages/adminModule/activity/video/VideoActivity")),
    AddInvoice: lazy(() => import("../pages/adminModule/billing/AddInvoice")),
    BillDetails: lazy(() => import("../pages/adminModule/billing/BillDetails")),
    BillInvoice: lazy(() => import("../pages/adminModule/billing/BillInvoice")),
    EditInvoice: lazy(() => import("../pages/adminModule/billing/EditInvoice")),
    AddChildren: lazy(() => import("../pages/adminModule/child/AddChildren")),
    ChildDetails: lazy(() => import("../pages/adminModule/child/ChildDetails")),
    ChildrenList: lazy(() => import("../pages/adminModule/child/ChildrenList")),
    EditChildren: lazy(() => import("../pages/adminModule/child/EditChildren")),
    CurriculumList: lazy(() => import("../pages/adminModule/curriculum/CurriculumList")),
    AdminDashboard: lazy(() => import("../pages/adminModule/dashboard/AdminDashboard")),
    DocumentList: lazy(() => import("../pages/adminModule/documents/DocumentList")),
    EventDetails: lazy(() => import("../pages/adminModule/events/EventDetails")),
    EventList: lazy(() => import("../pages/adminModule/events/EventList")),
    AddIncident: lazy(() => import("../pages/adminModule/incidentBehavior/AddIncident")),
    IncidentDetails: lazy(() => import("../pages/adminModule/incidentBehavior/IncidentDetails")),
    IncidentList: lazy(() => import("../pages/adminModule/incidentBehavior/IncidentList")),
    LeaveList: lazy(() => import("../pages/adminModule/leave/LeaveList")),
    MealDetails: lazy(() => import("../pages/adminModule/meals/MealDetails")),
    MealRoomList: lazy(() => import("../pages/adminModule/meals/MealRoomList")),
    MealsList: lazy(() => import("../pages/adminModule/meals/MealsList")),
    MessageLayout: lazy(() => import("../pages/adminModule/message/MessageLayout")),

    NewsLetterDetails: lazy(() => import("../pages/adminModule/newsLetter/NewsLetterDetails")),
    NewsList: lazy(() => import("../pages/adminModule/newsLetter/NewsList")),
    RoomList: lazy(() => import("../pages/adminModule/rooms/RoomList")),
    AddStaff: lazy(() => import("../pages/adminModule/staff/AddStaff")),
    AddStaffRole: lazy(() => import("../pages/adminModule/staff/AddStaffRole")),
    AddStaffShift: lazy(() => import("../pages/adminModule/staff/AddStaffShift")),
    AttendenceList: lazy(() => import("../pages/adminModule/staff/AttendenceList")),
    EditStaff: lazy(() => import("../pages/adminModule/staff/EditStaff")),
    EditStaffRole: lazy(() => import("../pages/adminModule/staff/EditStaffRole")),
    EditStaffShift: lazy(() => import("../pages/adminModule/staff/EditStaffShift")),
    StaffDetails: lazy(() => import("../pages/adminModule/staff/StaffDetails")),
    StaffList: lazy(() => import("../pages/adminModule/staff/StaffList")),
    StaffRole: lazy(() => import("../pages/adminModule/staff/StaffRole")),
    StaffShift: lazy(() => import("../pages/adminModule/staff/StaffShift")),
    StaffTimeStamp: lazy(() => import("../pages/adminModule/staff/StaffTimeStamp")),
    HRPayroll: lazy(() => import("../pages/adminModule/hr/HRPayroll")),
    ChildAttendance: lazy(() => import("../pages/adminModule/childAttendance/ChildAttendance")),
    AddPayroll: lazy(() => import("../pages/adminModule/hr/AddPayroll")),
    EditPayroll: lazy(() => import("../pages/adminModule/hr/EditPayroll")),
    PrivacyPolicy: lazy(() => import("../pages/adminModule/cms/PrivacyPolicy")),
    TermCondition: lazy(() => import("../pages/adminModule/cms/TermCondition")),
    Aboutus: lazy(() => import("../pages/adminModule/cms/Aboutus")),
    EditTimeStamp: lazy(() => import("../pages/adminModule/staff/EditTimeStamp")),
    RecentActivity: lazy(() => import("../pages/adminModule/Recents/RecentActivity")),
    WatingChild: lazy(() => import("../pages/adminModule/Recents/WatingChild")),
    ComplianceStatus: lazy(() => import("../pages/adminModule/Recents/ComplianceStatus")),
    LeaveCalender: lazy(() => import("../pages/adminModule/Recents/LeaveCalender")),
    PendingAction: lazy(() => import("../pages/adminModule/Recents/PendingAction")),
    AdminProfileDetails: lazy(() => import("../pages/adminModule/profile/AdminProfileDetails")),
    AssignKiosk: lazy(() => import("../pages/adminModule/assignKisok/Assignkiosk")),

}

const staffRoute = {
    Report: lazy(() => import("../pages/staffModule/report/Report")),
    StaffDashboard: lazy(() => import("../pages/staffModule/dashboard/StaffDashboard")),
    ProfileDetails: lazy(() => import("../pages/staffModule/profile/ProfileDetails")),
    EditProfileDetails: lazy(() => import("../pages/staffModule/profile/EditProfileDetails")),
    ActivityDetails: lazy(() => import("../pages/staffModule/activity/ActivityDetails")),
    AddBathRoomActivity: lazy(() => import("../pages/staffModule/activity/bathroom/AddBathRoomActivity")),
    BathroomActivity: lazy(() => import("../pages/staffModule/activity/bathroom/BathroomActivity")),
    AddBottleActivity: lazy(() => import("../pages/staffModule/activity/bottle/AddBottleActivity")),
    BottleActivity: lazy(() => import("../pages/staffModule/activity/bottle/BottleActivity")),
    AddLearnActivity: lazy(() => import("../pages/staffModule/activity/learning/AddLearnActivity")),
    LearningActivity: lazy(() => import("../pages/staffModule/activity/learning/LearningActivity")),
    AddMealActivity: lazy(() => import("../pages/staffModule/activity/meal/AddMealActivity")),
    MealActivity: lazy(() => import("../pages/staffModule/activity/meal/MealActivity")),
    AddMedsActivity: lazy(() => import("../pages/staffModule/activity/meds/AddMedsActivity")),
    MedsActivity: lazy(() => import("../pages/staffModule/activity/meds/MedsActivity")),
    AddMoodActivity: lazy(() => import("../pages/staffModule/activity/mood/AddMoodActivity")),
    MoodActivity: lazy(() => import("../pages/staffModule/activity/mood/MoodActivity")),
    AddNapActivity: lazy(() => import("../pages/staffModule/activity/nap/AddNapActivity")),
    NapActivity: lazy(() => import("../pages/staffModule/activity/nap/NapActivity")),
    AddNoteActivity: lazy(() => import("../pages/staffModule/activity/note/AddNoteActivity")),
    NoteActivity: lazy(() => import("../pages/staffModule/activity/note/NoteActivity")),
    AddPhotoActivity: lazy(() => import("../pages/staffModule/activity/photo/AddPhotoActivity")),
    PhotoActivity: lazy(() => import("../pages/staffModule/activity/photo/PhotoActivity")),
    AddVideoActivity: lazy(() => import("../pages/staffModule/activity/video/AddVideoActivity")),
    VideoActivity: lazy(() => import("../pages/staffModule/activity/video/VideoActivity")),
    AddInvoice: lazy(() => import("../pages/staffModule/billing/AddInvoice")),
    LeaveCalender: lazy(() => import("../pages/staffModule/Recents/LeaveCalender")),
    
    BillDetails: lazy(() => import("../pages/staffModule/billing/BillDetails")),
    BillInvoice: lazy(() => import("../pages/staffModule/billing/BillInvoice")),
    EditInvoice: lazy(() => import("../pages/staffModule/billing/EditInvoice")),
    AddChildren: lazy(() => import("../pages/staffModule/child/AddChildren")),
    ChildDetails: lazy(() => import("../pages/staffModule/child/ChildDetails")),
    ChildrenList: lazy(() => import("../pages/staffModule/child/ChildrenList")),
    Attendence: lazy(() => import("../pages/staffModule/attendence/Attendence")),
    EditChildren: lazy(() => import("../pages/staffModule/child/EditChildren")),
    CurriculumList: lazy(() => import("../pages/staffModule/curriculum/CurriculumList")),
    DocumentList: lazy(() => import("../pages/staffModule/documents/DocumentList")),
    EventDetails: lazy(() => import("../pages/staffModule/events/EventDetails")),
    EventList: lazy(() => import("../pages/staffModule/events/EventList")),
    AddIncident: lazy(() => import("../pages/staffModule/incidentBehavior/AddIncident")),
    IncidentDetails: lazy(() => import("../pages/staffModule/incidentBehavior/IncidentDetails")),
    IncidentList: lazy(() => import("../pages/staffModule/incidentBehavior/IncidentList")),
    LeaveList: lazy(() => import("../pages/staffModule/leave/LeaveList")),
    MealDetails: lazy(() => import("../pages/staffModule/meals/MealDetails")),
    MealRoomList: lazy(() => import("../pages/staffModule/meals/MealRoomList")),
    MealsList: lazy(() => import("../pages/staffModule/meals/MealsList")),
    MessageLayout: lazy(() => import("../pages/staffModule/message/MessageLayout")),
    EmptyChat: lazy(() => import("../pages/staffModule/message/EmptyChat")),

    NewsLetterDetails: lazy(() => import("../pages/staffModule/newsLetter/NewsLetterDetails")),
    NewsList: lazy(() => import("../pages/staffModule/newsLetter/NewsList")),
    RoomList: lazy(() => import("../pages/staffModule/rooms/RoomList")),
    AddStaff: lazy(() => import("../pages/staffModule/staff/AddStaff")),
    AddStaffRole: lazy(() => import("../pages/staffModule/staff/AddStaffRole")),
    AddStaffShift: lazy(() => import("../pages/staffModule/staff/AddStaffShift")),
    AttendenceList: lazy(() => import("../pages/staffModule/staff/AttendenceList")),
    EditStaff: lazy(() => import("../pages/staffModule/staff/EditStaff")),
    EditStaffRole: lazy(() => import("../pages/staffModule/staff/EditStaffRole")),
    EditStaffShift: lazy(() => import("../pages/staffModule/staff/EditStaffShift")),
    StaffDetails: lazy(() => import("../pages/staffModule/staff/StaffDetails")),
    StaffList: lazy(() => import("../pages/staffModule/staff/StaffList")),
    StaffRole: lazy(() => import("../pages/staffModule/staff/StaffRole")),
    StaffShift: lazy(() => import("../pages/staffModule/staff/StaffShift")),
    StaffTimeStamp: lazy(() => import("../pages/staffModule/staff/StaffTimeStamp")),
    HRPayroll: lazy(() => import("../pages/staffModule/hr/HRPayroll")),
    AddPayroll: lazy(() => import("../pages/staffModule/hr/AddPayroll")),
    MyAttendance: lazy(() => import("../pages/staffModule/myAttendance/MyAttendance")),
    EditPayroll: lazy(() => import("../pages/staffModule/hr/EditPayroll")),
    PrivacyPolicy: lazy(() => import("../pages/staffModule/cms/PrivacyPolicy")),
    TermCondition: lazy(() => import("../pages/staffModule/cms/TermCondition")),
    Aboutus: lazy(() => import("../pages/staffModule/cms/Aboutus")),
    RecentActivity: lazy(() => import("../pages/staffModule/Recents/RecentActivity")),
    ComplianceStatus: lazy(() => import("../pages/staffModule/Recents/ComplianceStatus")),
    WatingChild: lazy(() => import("../pages/staffModule/Recents/WatingChild")),
    PendingAction: lazy(() => import("../pages/staffModule/Recents/PendingAction")),

}

const parentRoute = {
    ParentDashboard: lazy(() => import("../pages/parentModule/dashboard/ParentDashboard")),
    ActivityDetails: lazy(() => import("../pages/parentModule/activity/ActivityDetails")),
    BathroomActivity: lazy(() => import("../pages/parentModule/activity/bathroom/BathroomActivity")),
    BottleActivity: lazy(() => import("../pages/parentModule/activity/bottle/BottleActivity")),
    LearningActivity: lazy(() => import("../pages/parentModule/activity/learning/LearningActivity")),
    MealActivity: lazy(() => import("../pages/parentModule/activity/meal/MealActivity")),
    MedsActivity: lazy(() => import("../pages/parentModule/activity/meds/MedsActivity")),
    MoodActivity: lazy(() => import("../pages/parentModule/activity/mood/MoodActivity")),
    NapActivity: lazy(() => import("../pages/parentModule/activity/nap/NapActivity")),
    NoteActivity: lazy(() => import("../pages/parentModule/activity/note/NoteActivity")),
    PhotoActivity: lazy(() => import("../pages/parentModule/activity/photo/PhotoActivity")),
    VideoActivity: lazy(() => import("../pages/parentModule/activity/video/VideoActivity")),
    AddInvoice: lazy(() => import("../pages/parentModule/billing/AddInvoice")),
    BillDetails: lazy(() => import("../pages/parentModule/billing/BillDetails")),
    BillInvoice: lazy(() => import("../pages/parentModule/billing/BillInvoice")),
    EditInvoice: lazy(() => import("../pages/parentModule/billing/EditInvoice")),
    CurriculumList: lazy(() => import("../pages/parentModule/curriculum/CurriculumList")),

    EventList: lazy(() => import("../pages/parentModule/events/EventList")),
    IncidentDetails: lazy(() => import("../pages/parentModule/incidentBehavior/IncidentDetails")),
    IncidentList: lazy(() => import("../pages/parentModule/incidentBehavior/IncidentList")),
    MealDetails: lazy(() => import("../pages/parentModule/meals/MealDetails")),
    MealsList: lazy(() => import("../pages/parentModule/meals/MealsList")),
    MessageLayout: lazy(() => import("../pages/parentModule/message/MessageLayout")),
    EmptyChat: lazy(() => import("../pages/parentModule/message/EmptyChat")),
    NewsLetterDetails: lazy(() => import("../pages/parentModule/newsLetter/NewsLetterDetails")),
    NewsList: lazy(() => import("../pages/parentModule/newsLetter/NewsList")),
    Attendence: lazy(() => import("../pages/parentModule/attendence/Attendence")),

    EmergencyContact: lazy(() => import("../pages/parentModule/childSafety/EmergencyContact/EmergencyContact")),
    AuthorisedPickup: lazy(() => import("../pages/parentModule/childSafety/Authorised/AuthorisedPickup")),
    UnAuthorisedPickup: lazy(() => import("../pages/parentModule/childSafety/UnAuthorised/UnAuthorisedPickup")),
    ParentProfileDetails: lazy(() => import("../pages/parentModule/profile/ParentProfileDetails")),
    EditParentProfileDetails: lazy(() => import("../pages/parentModule/profile/EditParentProfileDetails")),
    PrivacyPolicy: lazy(() => import("../pages/parentModule/cms/PrivacyPolicy")),
    TermCondition: lazy(() => import("../pages/parentModule/cms/TermCondition")),
    Aboutus: lazy(() => import("../pages/parentModule/cms/Aboutus")),
    EditIncident: lazy(() => import("../pages/parentModule/incidentBehavior/EditIncident")),
    EventDetails: lazy(() => import("../pages/parentModule/events/EventDetails")),

}

// auth route 
export const authRoute = [
    { path: "/login", element: <Login /> },
    { path: "/signin-kiosk", element: <SigninKiosk /> },
    { path: "/pin-validate", element: <PinValidate /> },
    { path: "/add-new-profile", element: <AddNewProfile /> },
]

export const routeCollection = [

    {
        path: "/admin-dashboard",
        element: <adminRoute.AdminDashboard />,
        index: true
    },

    {
        path: "/profile",
        element: <adminRoute.AdminProfileDetails />,
    },

    {
        path: "/assign-kiosk",
        element: <adminRoute.AssignKiosk />,
    },

    {
        path: "report",
        element: <adminRoute.Report />,
    },
    {
        path: "photo-activity",
        element: <adminRoute.PhotoActivity />,
    },
    {
        path: "meal-details/:id",
        element: <adminRoute.MealDetails />,
    },
    {
        path: "video-activity",
        element: <adminRoute.VideoActivity />,
    },
    {
        path: "learning-activity",
        element: <adminRoute.LearningActivity />,
    },
    {
        path: "meal-activity",
        element: <adminRoute.MealActivity />,
    },
    {
        path: "nap-activity",
        element: <adminRoute.NapActivity />,
    },
    {
        path: "bathroom-activity",
        element: <adminRoute.BathroomActivity />,
    },
    {
        path: "bottle-activity",
        element: <adminRoute.BottleActivity />,
    },
    {
        path: "mood-activity",
        element: <adminRoute.MoodActivity />,
    },
    {
        path: "meds-activity",

        element: <adminRoute.MedsActivity />,
    },
    {
        path: "note-activity",
        element: <adminRoute.NoteActivity />,
    },

    {
        path: "room",
        element: <adminRoute.RoomList />,
    },
    {
        path: "child",
        element: <adminRoute.ChildrenList />,
    },
    {
        path: "incident-behavior",
        element: <adminRoute.IncidentList />,
    },
    {
        path: "add-incident-behavior",
        element: <adminRoute.AddIncident />,
    },
    {
        path: "event",
        element: <adminRoute.EventList />,
    },

    {
        path: "event-details/:id",
        element: <adminRoute.EventDetails />,
    },
    {
        path: "incident-behavior-details/:id",
        element: <adminRoute.IncidentDetails />,
    },

    {
        path: "add-child",
        element: <adminRoute.AddChildren />,
    },
    {
        path: "child-attendance",
        element: <adminRoute.ChildAttendance />,
    },
    {
        path: "activity-details/:type/:id",
        element: <adminRoute.ActivityDetails />,
    },
    {
        path: "edit-child/:id",
        element: <adminRoute.EditChildren />,
    },
    {
        path: "staff-role",
        element: <adminRoute.StaffRole />,
    },
    {
        path: "add-staff",
        element: <adminRoute.AddStaff />,
    },
    {
        path: "add-invoice",
        element: <adminRoute.AddInvoice />,
    },
    {
        path: "edit-invoice/:id",
        element: <adminRoute.EditInvoice />,
    },
    {
        path: "add-staff-role",
        element: <adminRoute.AddStaffRole />,
    },
    {
        path: "edit-staff-role/:id",
        element: <adminRoute.EditStaffRole />,
    },
    {
        path: "add-staff-shift",
        element: <adminRoute.AddStaffShift />,
    },


    {
        path: "add-photo-activity",
        element: <adminRoute.AddPhotoActivity />,
    },

    {
        path: "add-video-activity",
        element: <adminRoute.AddVideoActivity />,
    },
    {
        path: "add-bathroom-activity",
        element: <adminRoute.AddBathRoomActivity />,
    },
    {
        path: "add-bottle-activity",
        element: <adminRoute.AddBottleActivity />,
    },
    {
        path: "add-photo-activity",
        element: <adminRoute.AddPhotoActivity />,
    },
    {
        path: "add-learning-activity",
        element: <adminRoute.AddLearnActivity />,
    },
    {
        path: "add-meal-activity",
        element: <adminRoute.AddMealActivity />,
    },
    {
        path: "add-meds-activity",
        element: <adminRoute.AddMedsActivity />,
    },
    {
        path: "add-mood-activity",
        element: <adminRoute.AddMoodActivity />,
    },
    {
        path: "add-nap-activity",
        element: <adminRoute.AddNapActivity />,
    },
    {
        path: "add-note-activity",
        element: <adminRoute.AddNoteActivity />,
    },
    {
        path: "add-payroll",
        element: <adminRoute.AddPayroll />,
    },
    {
        path: "edit-payroll/:id",
        element: <adminRoute.EditPayroll />,
    },

    {
        path: "staff-details/:id",
        element: <adminRoute.StaffDetails />,
    },
    {
        path: "edit-staff/:id",
        element: <adminRoute.EditStaff />,
    },
    {
        path: "invoice-details/:id",
        element: <adminRoute.BillDetails />,
    },
    {
        path: "edit-staff-shift/:id",
        element: <adminRoute.EditStaffShift />,
    },
    {
        path: "child-details/:id",
        element: <adminRoute.ChildDetails />,
    },
    {
        path: "staff",
        element: <adminRoute.StaffList />,
    },
    {
        path: "staff-attendence",
        element: <adminRoute.AttendenceList />,
    },
    {
        path: "staff-shift",
        element: <adminRoute.StaffShift />,
    },
    {
        path: "staff-Times-Stamps",
        element: <adminRoute.StaffTimeStamp />,
    },
    {
        path: "edit-staff-Times-Stamps/:id",
        element: <adminRoute.EditTimeStamp />,
    },
    {
        path: "curriculum",
        element: <adminRoute.CurriculumList />,
    },
    {
        path: "meals-plan/:id",
        element: <adminRoute.MealsList />,
    },
    {
        path: "meals-plan-room",
        element: <adminRoute.MealRoomList />,
    },
    {
        path: "leave-request",
        element: <adminRoute.LeaveList />,
    },
    {
        path: "documents",
        element: <adminRoute.DocumentList />,
    },
    {
        path: "message",
        element: <adminRoute.MessageLayout />,
    },


    {
        path: "news-letter/:id",
        element: <adminRoute.NewsLetterDetails />,
    },
    {
        path: "bill",
        element: <adminRoute.BillInvoice />,
    },
    {
        path: "hr-payroll",
        element: <adminRoute.HRPayroll />,
    },
    {
        path: "news-letter",
        element: <adminRoute.NewsList />,
    },

    {
        path: "privacy-policy",
        element: <adminRoute.PrivacyPolicy />,
    },
    {
        path: "term-condition",
        element: <adminRoute.TermCondition />,
    },
    {
        path: "aboutus",
        element: <adminRoute.Aboutus />,
    },
    {
        path: "recent-activity",
        element: <adminRoute.RecentActivity />,
    },
    {
        path: "compliance-status",
        element: <adminRoute.ComplianceStatus />,
    },
    {
        path: "leave-calender",
        element: <adminRoute.LeaveCalender />,
    },
    {
        path: "pending-action",
        element: <adminRoute.PendingAction />,
    },
    {
        path: "waitlist-children",
        element: <adminRoute.WatingChild />,
    },

];

export const staffRouteCollection = [

    {
        path: "/staff/dashboard",
        element: <staffRoute.StaffDashboard />,
        index: true
    },
    {
        path: "/staff/report",
        element: <staffRoute.Report />,
    },

    {
        path: "/staff/profile-details",
        element: <staffRoute.ProfileDetails />,
        index: true
    },
    {
        path: "/staff/edit-profile-details",
        element: <staffRoute.EditProfileDetails />,
    },
    {
        path: "/staff/photo-activity",
        element: <staffRoute.PhotoActivity />,
    },
    {
        path: "/staff/meal-details/:id",
        element: <staffRoute.MealDetails />,
    },
    {
        path: "/staff/video-activity",
        element: <staffRoute.VideoActivity />,
    },
    {
        path: "/staff/learning-activity",
        element: <staffRoute.LearningActivity />,
    },
    {
        path: "/staff/meal-activity",
        element: <staffRoute.MealActivity />,
    },
    {
        path: "/staff/nap-activity",
        element: <staffRoute.NapActivity />,
    },
    {
        path: "/staff/bathroom-activity",
        element: <staffRoute.BathroomActivity />,
    },
    {
        path: "/staff/bottle-activity",
        element: <staffRoute.BottleActivity />,
    },
    {
        path: "/staff/mood-activity",
        element: <staffRoute.MoodActivity />,
    },
    {
        path: "/staff/meds-activity",

        element: <staffRoute.MedsActivity />,
    },
    {
        path: "/staff/note-activity",
        element: <staffRoute.NoteActivity />,
    },

    {
        path: "/staff/room",
        element: <staffRoute.RoomList />,
    },
    {
        path: "/staff/child",
        element: <staffRoute.ChildrenList />,
    },
    {
        path: "/staff/incident-behavior",
        element: <staffRoute.IncidentList />,
    },
    {
        path: "/staff/add-incident-behavior",
        element: <staffRoute.AddIncident />,
    },
    {
        path: "/staff/event",
        element: <staffRoute.EventList />,
    },

    {
        path: "/staff/event-details/:id",
        element: <staffRoute.EventDetails />,
    },
    {
        path: "/staff/incident-behavior-details/:id",
        element: <staffRoute.IncidentDetails />,
    },

    {
        path: "/staff/add-child",
        element: <staffRoute.AddChildren />,
    },
    {
        path: "/staff/child-attendance",
        element: <staffRoute.Attendence />,
    },
    {
        path: "/staff/activity-details/:type/:id",
        element: <staffRoute.ActivityDetails />,
    },
    {
        path: "/staff/edit-child/:id",
        element: <staffRoute.EditChildren />,
    },
    {
        path: "/staff/staff-role",
        element: <staffRoute.StaffRole />,
    },
    {
        path: "/staff/add-staff",
        element: <staffRoute.AddStaff />,
    },
    {
        path: "/staff/add-invoice",
        element: <staffRoute.AddInvoice />,
    },

    {
        path: "/staff/edit-invoice/:id",
        element: <staffRoute.EditInvoice />,
    },
    {
        path: "/staff/add-staff-role",
        element: <staffRoute.AddStaffRole />,
    },
    {
        path: "/staff/edit-staff-role/:id",
        element: <staffRoute.EditStaffRole />,
    },
    {
        path: "/staff/add-staff-shift",
        element: <staffRoute.AddStaffShift />,
    },


    {
        path: "/staff/add-photo-activity",
        element: <staffRoute.AddPhotoActivity />,
    },

    {
        path: "/staff/add-video-activity",
        element: <staffRoute.AddVideoActivity />,
    },
    {
        path: "/staff/add-bathroom-activity",
        element: <staffRoute.AddBathRoomActivity />,
    },
    {
        path: "/staff/add-bottle-activity",
        element: <staffRoute.AddBottleActivity />,
    },
    {
        path: "/staff/add-photo-activity",
        element: <staffRoute.AddPhotoActivity />,
    },
    {
        path: "/staff/add-learning-activity",
        element: <staffRoute.AddLearnActivity />,
    },
    {
        path: "/staff/add-meal-activity",
        element: <staffRoute.AddMealActivity />,
    },
    {
        path: "/staff/add-meds-activity",
        element: <staffRoute.AddMedsActivity />,
    },
    {
        path: "/staff/add-mood-activity",
        element: <staffRoute.AddMoodActivity />,
    },
    {
        path: "/staff/add-nap-activity",
        element: <staffRoute.AddNapActivity />,
    },
    {
        path: "/staff/add-note-activity",
        element: <staffRoute.AddNoteActivity />,
    },


    {
        path: "/staff/staff-details/:id",
        element: <staffRoute.StaffDetails />,
    },
    {
        path: "/staff/edit-staff/:id",
        element: <staffRoute.EditStaff />,
    },
    {
        path: "/staff/invoice-details/:id",
        element: <staffRoute.BillDetails />,
    },
    {
        path: "/staff/edit-staff-shift/:id",
        element: <staffRoute.EditStaffShift />,
    },
    {
        path: "/staff/child-details/:id",
        element: <staffRoute.ChildDetails />,
    },
    {
        path: "/staff/staff",
        element: <staffRoute.StaffList />,
    },
    {
        path: "/staff/staff-attendence",
        element: <staffRoute.AttendenceList />,
    },
    {
        path: "/staff/staff-shift",
        element: <staffRoute.StaffShift />,
    },
    {
        path: "/staff/staff-Times-Stamps",
        element: <staffRoute.StaffTimeStamp />,
    },
    {
        path: "/staff/curriculum",
        element: <staffRoute.CurriculumList />,
    },
    {
        path: "/staff/meals-plan/:id",
        element: <staffRoute.MealsList />,
    },
    {
        path: "/staff/meals-plan-room",
        element: <staffRoute.MealRoomList />,
    },
    {
        path: "/staff/leave-request",
        element: <staffRoute.LeaveList />,
    },
    {
        path: "/staff/add-leave-request",
        element: <staffRoute.AddLeave />,
    },
    {
        path: "/staff/documents",
        element: <staffRoute.DocumentList />,
    },
    {
        path: "/staff/message",
        element: <staffRoute.MessageLayout />,

    },
    {
        path: "/staff/news-letter/:id",
        element: <staffRoute.NewsLetterDetails />,
    },
    {
        path: "/staff/bill",
        element: <staffRoute.BillInvoice />,
    },
    {
        path: "/staff/hr-payroll",
        element: <staffRoute.HRPayroll />,
    },
    {
        path: "/staff/add-payroll",
        element: <staffRoute.AddPayroll />,
    },
    {
        path: "/staff/news-letter",
        element: <staffRoute.NewsList />,
    },
    {
        path: "/staff/my-attendance",
        element: <staffRoute.MyAttendance />,
    },
    {
        path: "/staff/add-payroll",
        element: <staffRoute.AddPayroll />,
    },
    {
        path: "/staff/edit-payroll/:id",
        element: <staffRoute.EditPayroll />,
    },
    {
        path: "/staff/privacy-policy",
        element: <staffRoute.PrivacyPolicy />,
    },
    {
        path: "/staff/term-condition",
        element: <staffRoute.TermCondition />,
    },
    {
        path: "/staff/aboutus",
        element: <staffRoute.Aboutus />,
    },
    {
        path: "/staff/recent-activity",
        element: <staffRoute.RecentActivity />,
    },
    {
        path: "/staff/leave-calender",
        element: <staffRoute.LeaveCalender />,
    },
    {
        path: "/staff/compliance-status",
        element: <staffRoute.ComplianceStatus />,
    },
    {
        path: "/staff/pending-action",
        element: <staffRoute.PendingAction />,
    },
    {
        path: "/staff/waitlist-children",
        element: <staffRoute.WatingChild />,
    },

];

export const parentRouteCollection = [
    {
        path: "/parent/dashboard",
        element: <parentRoute.ParentDashboard />,
        index: true
    },
    {
        path: "/parent/profile-details",
        element: <parentRoute.ParentProfileDetails />,
    },
    {
        path: "/parent/edit-child-profile",
        element: <parentRoute.EditParentProfileDetails />,
    },
    {
        path: "/parent/photo-activity",
        element: <parentRoute.PhotoActivity />,
    },
    {
        path: "/parent/meal-details",
        element: <parentRoute.MealDetails />,
    },
    {
        path: "/parent/video-activity",
        element: <parentRoute.VideoActivity />,
    },
    {
        path: "/parent/learning-activity",
        element: <parentRoute.LearningActivity />,
    },
    {
        path: "/parent/meal-activity",
        element: <parentRoute.MealActivity />,
    },
    {
        path: "/parent/nap-activity",
        element: <parentRoute.NapActivity />,
    },
    {
        path: "/parent/bathroom-activity",
        element: <parentRoute.BathroomActivity />,
    },
    {
        path: "/parent/bottle-activity",
        element: <parentRoute.BottleActivity />,
    },
    {
        path: "/parent/mood-activity",
        element: <parentRoute.MoodActivity />,
    },
    {
        path: "/parent/meds-activity",

        element: <parentRoute.MedsActivity />,
    },
    {
        path: "/parent/note-activity",
        element: <parentRoute.NoteActivity />,
    },
    {
        path: "/parent/activity-details/:type/:id",
        element: <parentRoute.ActivityDetails />,
    },
    {
        path: "/parent/event",
        element: <parentRoute.EventList />,
    },
    {
        path: "parent/event-details/:id",
        element: <parentRoute.EventDetails />,
    },

    {
        path: "/parent/incident-behavior",
        element: <parentRoute.IncidentList />,
    },
    {
        path: "/parent/edit-incident-behavior/:id",
        element: <parentRoute.EditIncident />,
    },

    {
        path: "/parent/incident-behavior-details/:id",
        element: <parentRoute.IncidentDetails />,
    },

    {
        path: "/parent/invoice-details/:id",
        element: <parentRoute.BillDetails />,
    },

    {
        path: "/parent/curriculum",
        element: <parentRoute.CurriculumList />,
    },
    {
        path: "/parent/meals-plan",
        element: <parentRoute.MealsList />,
    },
    {
        path: "/parent/meals-plan-room",
        element: <parentRoute.MealRoomList />,
    },

    {
        path: "/parent/meal-details/:id",
        element: <parentRoute.MealDetails />,
    },

    {
        path: "/parent/message",
        element: <parentRoute.MessageLayout />,

    },
    {
        path: "/parent/news-letter/:id",
        element: <parentRoute.NewsLetterDetails />,
    },
    {
        path: "/parent/bill",
        element: <parentRoute.BillInvoice />,
    },

    {
        path: "/parent/news-letter",
        element: <parentRoute.NewsList />,
    },
    {
        path: "/parent/emergency-contact",
        element: <parentRoute.EmergencyContact />,
    },
    {
        path: "/parent/authorised-pickup",
        element: <parentRoute.AuthorisedPickup />,
    },
    {
        path: "/parent/unauthorised-pickup",
        element: <parentRoute.UnAuthorisedPickup />,
    },
    {
        path: "/parent/attendance",
        element: <parentRoute.Attendence />,
    },

    {
        path: "/parent/privacy-policy",
        element: <parentRoute.PrivacyPolicy />,
    },
    {
        path: "/parent/term-condition",
        element: <parentRoute.TermCondition />,
    },
    {
        path: "/parent/aboutus",
        element: <parentRoute.Aboutus />,
    },
];


